export default "__VITE_ASSET__CP1FEa7W__"